// extracted by mini-css-extract-plugin
module.exports = {"pricingWrap":"pricing-content_pricingWrap__8B9vt"};